module.exports = __webpack_public_path__ + "media/customizations/rksouthhoa/logo-7ae956e3c0933021a0ac198b85b11182.png";